export default __webpack_public_path__ + "static/media/disabled_bus_redencao.840faacb.jpg";